/* Letters archive — category filter chips.
   Chips: [data-twb-filter="all|business|machines|homefront"]
   Rows:  [data-twb-cat="business|machines|homefront"]
   Mirrors the prototype state logic:
     all active      -> ink bg / cream text
     category active -> its colour bg / ink text
     inactive        -> transparent bg / ink text */
(function () {
  var COLORS = { business: '#7FC8C2', machines: '#F4A09C', homefront: '#F5C97B' };
  var INK = '#43342B';
  var CREAM = '#FDF6E3';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var chips = Array.prototype.slice.call(document.querySelectorAll('[data-twb-filter]'));
    var rows = Array.prototype.slice.call(document.querySelectorAll('[data-twb-cat]'));
    if (!chips.length) return;

    function apply(filter) {
      chips.forEach(function (chip) {
        var f = chip.getAttribute('data-twb-filter');
        var active = f === filter;
        if (f === 'all') {
          chip.style.background = active ? INK : 'transparent';
          chip.style.color = active ? CREAM : INK;
        } else {
          chip.style.background = active ? COLORS[f] : 'transparent';
          chip.style.color = INK;
        }
      });
      rows.forEach(function (row) {
        var show = filter === 'all' || row.getAttribute('data-twb-cat') === filter;
        row.style.display = show ? 'flex' : 'none';
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        apply(chip.getAttribute('data-twb-filter'));
      });
    });
  });
})();
